module.exports = __webpack_public_path__ + "img/boomerang.f44cd2dc.svg";